import React from 'react'
import { Card } from 'antd';

import './index.less'

export default class PanelBox extends React.Component {
  render () {
    return (
      <Card className={"panel-box " + this.props.className} title={this.props.title} bordered={false} bodyStyle={this.props.bodyStyle} style={{textAlign: 'center'}}>
        {this.props.children}
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PanelBox/index.jsx